module.exports = __webpack_public_path__ + "static/media/equipamentosSamsung.81ffd5a9.png";